var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { st, classes } from './MobileDrawer.st.css';
import { Modal } from '../internal/Modal';
/** MobileDrawers provide access to destinations and functionality menus, such as Action Menus, Filter Dropdown etc. This component should be used on mobile only. */
var MobileDrawer = /** @class */ (function (_super) {
    __extends(MobileDrawer, _super);
    function MobileDrawer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            visible: false,
        };
        return _this;
    }
    MobileDrawer.prototype._onRequestClose = function () {
        this.setState({ visible: false });
        this.props.onRequestClose();
    };
    MobileDrawer.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.isOpen && !this.state.visible) {
            setTimeout(function () {
                _this.setState({ visible: true });
            }, 0);
        }
    };
    MobileDrawer.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (this.props.isOpen && !this.state.visible) {
            setTimeout(function () {
                _this.setState({ visible: true });
            }, 0);
        }
        if (prevProps.isOpen && !this.props.isOpen) {
            this.setState({ visible: false });
        }
    };
    MobileDrawer.prototype.render = function () {
        var _this = this;
        var _a = this.props, isOpen = _a.isOpen, children = _a.children, ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], ariaDescribedBy = _a["aria-describedby"], className = _a.className;
        var visible = this.state.visible;
        return (React.createElement("div", { className: st(classes.root, className), "data-hook": this.props['data-hook'] },
            React.createElement(Modal, { isOpen: isOpen, onRequestClose: function () { return _this._onRequestClose(); } },
                React.createElement("div", { className: st(classes.contentWrapper, { visible: visible }), role: "dialog", "aria-modal": "true", "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy }, children))));
    };
    MobileDrawer.displayName = 'MobileDrawer';
    MobileDrawer.defaultProps = {
        isOpen: false,
        onRequestClose: function () { },
    };
    return MobileDrawer;
}(React.Component));
export { MobileDrawer };
//# sourceMappingURL=MobileDrawer.js.map